import React, { Component } from "react";
import { getCities } from "../../api/flightApi";
import PropTypes from "prop-types";
import axios from "axios";
import {
    DatePicker,
    Counter,
    Loading as LoadingScreen,
    Modal,
    IconInput,
    Dropdown as DropdownItem,
} from "../shared";
import { Formik, Form, Field } from "formik";
import ErrorMessage from "../ErrorMessage";
import * as yup from "yup";
import { passCsrfToken, subDays, addDays, ifNotZero } from "../../helpers";
import { connect } from "react-redux";
import {
    setFlights,
    setSearchDetails,
    setTTLtime,
    setError,
    clearFlights,
} from "../../redux/actions";
import history from "../../history";
import { Dropdown } from "semantic-ui-react";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";
import { Radio } from "semantic-ui-react";
import "../../i18n";
import { withTranslation } from "react-i18next";
import {
    mergeSectorsWithFallback,
    resolveDefaultSectors,
    sectorDropdownOptions,
    POPULAR_NEPAL_FLIGHT_ROUTES,
} from "./flightSectorHelpers";

class SearchBar extends Component {
    constructor(props) {
        super(props);
        var date = new Date();
        date.setDate(date.getDate() + 2);
        this.state = {
            cities: [],
            hideReturnField: true,
            availableFlights: [],
            tripType: "O",
        };
        this.strSectorFrom = React.createRef();
        this.strSectorTo = React.createRef();
    }

    componentDidMount() {
        passCsrfToken(document, axios);
        this.setState({
            searchDetails: this.props.searchDetails,
        });
        this.fetchCities();
    }

    fetchCities = () => {
        getCities()
            .then((response) => {
                this.setState({
                    cities: response.data,
                });
            })
            .catch((error) => {
                console.log(" city fetch error", error);
                this.setState({
                    cities: mergeSectorsWithFallback([]),
                });
            });
    };

    changeTripType = (trip) => {
        this.setState({
            tripType: trip,
            hideReturnField: trip == "O" ? true : false,
        });
    };

    toggleTripType = () => {
        var value = this.state.tripType == "R" ? "O" : "R";
        this.setState(function (prevState) {
            return {
                tripType: prevState.tripType == "R" ? "O" : "R",
                hideReturnField: !prevState.hideReturnField,
            };
        });
        return value;
    };

    toggleSectors = () => {
        this.strSectorFrom.current;
        console.log("Changed SearchDetails", this.state.searchDetails);
        this.props.setSearchDetails(
            Object.assign({}, this.state.searchDetails, {
                strSectorFrom: this.state.searchDetails.strSectorTo,
                strSectorTo: this.state.searchDetails.strSectorFrom,
            })
        );
    };

    render() {
        const { hideReturnField, cities, minDate } = this.state;
        const { searchDetails, countries, setError, t, i18n } = this.props;

        console.log("Search Details", searchDetails);

        const SearchFlightSchema = yup.object().shape({
            strFlightDate: yup
                .date()
                .required("Required")
                .default(function () {
                    return new Date();
                }),
            strReturnDate: yup.date().default(function () {
                return yup.ref("strFlightDate");
            }),
            strSectorFrom: yup.string().required("Required"),
            strSectorTo: yup.string().required("Required"),
            strNationality: yup.string().required("Required"),
            totalPax: yup.number().min(1, "Traveller cannot be zero"),
        });

        const details = searchDetails || {};
        const sectorDefaults = resolveDefaultSectors(cities, details);
        const initialValues = {
            ...details,
            ...sectorDefaults,
            totalPax: (details.intAdult || 0) + (details.intChild || 0),
        };

        return (
            <div id="search-flight-form" className="flights-booking-form">
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={SearchFlightSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        this.props.clearFlights();
                        this.props.setSearchDetails(values);
                        history.push("/flights");
                        this.props.onSearch && this.props.onSearch();
                        setSubmitting(false);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        /* and other goodies */
                    }) => (
                        <form
                            onSubmit={handleSubmit}
                            autoComplete="off"
                            className="form-wrap flights-booking-form__form"
                        >
                            <div className="input-section padded flights-booking-form__fields">
                                <div className="form-menu flights-trip-tabs d-flex">
                                    <span
                                        className={
                                            values.strTripType == "O"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setFieldValue("strTripType", "O");
                                            this.changeTripType("O");
                                        }}
                                    >
                                        {t("OneWay")}
                                    </span>
                                    <span
                                        className={
                                            values.strTripType == "R"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => {
                                            setFieldValue("strTripType", "R");
                                            this.changeTripType("R");
                                        }}
                                    >
                                        {t("RoundTrip")}
                                    </span>
                                </div>

                                {cities.length > 0 && (
                                    <div className="flights-quick-routes">
                                        {POPULAR_NEPAL_FLIGHT_ROUTES.map(
                                            (route) => (
                                                <button
                                                    key={route.label}
                                                    type="button"
                                                    className="flights-quick-routes__chip"
                                                    onClick={() => {
                                                        setFieldValue(
                                                            "strSectorFrom",
                                                            route.from
                                                        );
                                                        setFieldValue(
                                                            "strSectorTo",
                                                            route.to
                                                        );
                                                    }}
                                                >
                                                    {route.label}
                                                </button>
                                            )
                                        )}
                                    </div>
                                )}

                                <div className="flights-search-grid flights-search-grid--route">
                                    <div className="field-box flights-search-grid__from">
                                        <label>{t("Leaving From")}</label>
                                        <Dropdown
                                            name="strSectorFrom"
                                            onBlur={handleBlur}
                                            className="icon btn-dropdown"
                                            iconPosition="left"
                                            icon="fas fa-plane departure"
                                            onChange={(e, data) => {
                                                setFieldValue(
                                                    `strSectorFrom`,
                                                    data.value
                                                );
                                            }}
                                            placeholder={"Leaving From"}
                                            value={values.strSectorFrom}
                                            fluid
                                            search
                                            selection
                                            selectOnBlur={false}
                                            options={sectorDropdownOptions(
                                                cities,
                                                {
                                                    excludeCode:
                                                        values.strSectorTo,
                                                }
                                            )}
                                        />
                                        <ErrorMessage name="strSectorFrom" />
                                        <div className="toggle-sector-mobile">
                                            <i
                                                className="fas fa-exchange-alt"
                                                onClick={() => {
                                                    setFieldValue(
                                                        "strSectorTo",
                                                        values.strSectorFrom
                                                    );
                                                    setFieldValue(
                                                        "strSectorFrom",
                                                        values.strSectorTo
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="flights-search-grid__swap toggle-sector-desktop">
                                        <button
                                            type="button"
                                            className="flights-search-grid__swap-btn"
                                            aria-label="Swap origin and destination"
                                            onClick={() => {
                                                setFieldValue(
                                                    "strSectorTo",
                                                    values.strSectorFrom
                                                );
                                                setFieldValue(
                                                    "strSectorFrom",
                                                    values.strSectorTo
                                                );
                                            }}
                                        >
                                            <i className="fas fa-exchange-alt" />
                                        </button>
                                    </div>
                                    <div className="field-box flights-search-grid__to">
                                        <label>{t("Going To")}</label>
                                        <Dropdown
                                            name="strSectorTo"
                                            onBlur={handleBlur}
                                            className="icon btn-dropdown"
                                            iconPosition="left"
                                            icon="fas fa-plane arrival"
                                            placeholder={"Going To"}
                                            value={values.strSectorTo}
                                            onChange={(e, data) => {
                                                setFieldValue(
                                                    `strSectorTo`,
                                                    data.value
                                                );
                                            }}
                                            fluid
                                            search
                                            selection
                                            selectOnBlur={false}
                                            options={sectorDropdownOptions(
                                                cities,
                                                {
                                                    excludeCode:
                                                        values.strSectorFrom,
                                                }
                                            )}
                                        />

                                        <ErrorMessage name="strSectorTo" />
                                    </div>
                                </div>
                                <div
                                    className={`flights-search-grid flights-search-grid--details ${
                                        values.strTripType == "R"
                                            ? "flights-search-grid--round"
                                            : ""
                                    }`}
                                >
                                    <div className="field-box flights-search-grid__depart">
                                        <label>{t("Departure Date")}</label>
                                        <DatePicker
                                            name="strFlightDate"
                                            className="form-control"
                                            type="date"
                                            date={values.strFlightDate}
                                            minDate={new Date()}
                                            maxDate={addDays(new Date(), 365)}
                                            onBlur={handleBlur}
                                            onChange={(date) =>
                                                setFieldValue(
                                                    "strFlightDate",
                                                    date
                                                )
                                            }
                                            value={values.strFlightDate}
                                            placeholder="Departure Date"
                                        />
                                        <ErrorMessage name="strFlightDate" />
                                        <div className="toggle-trip">
                                            <Radio
                                                toggle
                                                checked={
                                                    this.state.tripType == "R"
                                                }
                                                onChange={() => {
                                                    setFieldValue(
                                                        "strTripType",
                                                        this.toggleTripType()
                                                    );
                                                }}
                                                value={this.state.tripType}
                                            />
                                            <span className="label">
                                                Round Trip?
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className={`field-box flights-search-grid__return ${
                                            values.strTripType == "O"
                                                ? "d-none"
                                                : ""
                                        }`}
                                    >
                                        <label>{t("Arrival Date")}</label>
                                        <DatePicker
                                            name="strReturnDate"
                                            className="form-control"
                                            type="date"
                                            date={values.strReturnDate}
                                            minDate={values.strFlightDate}
                                            maxDate={addDays(new Date(), 365)}
                                            onBlur={handleBlur}
                                            onChange={(date) =>
                                                setFieldValue(
                                                    "strReturnDate",
                                                    date
                                                )
                                            }
                                            value={values.strReturnDate}
                                            placeholder="Arrival Date"
                                        />
                                        <ErrorMessage name="strReturnDate" />
                                    </div>
                                    <div className="field-box flights-search-grid__pax">
                                        <label>{t("Traveller(s)")}</label>
                                        <Dropdown
                                            name="travellers"
                                            icon="users"
                                            iconPosition="left"
                                            className="icon btn-dropdown travellers"
                                            fluid
                                            selection
                                            closeOnChange={false}
                                            text={`${ifNotZero(
                                                values.intAdult,
                                                `${values.intAdult} Adult`
                                            )}${ifNotZero(
                                                values.intChild,
                                                `, ${values.intChild} Child`
                                            )}`}
                                        >
                                            <Dropdown.Menu
                                                onClick={(e, data) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                }}
                                                content={
                                                    <div className="px-2">
                                                        <Counter
                                                            id="intAdult"
                                                            type="number"
                                                            className="m-1"
                                                            onBlur={handleBlur}
                                                            title={"Adult".pluralize(
                                                                values.intAdult
                                                            )}
                                                            onChange={(
                                                                value
                                                            ) => {
                                                                setFieldValue(
                                                                    "intAdult",
                                                                    value
                                                                );
                                                                setFieldValue(
                                                                    "totalPax",
                                                                    values.intChild +
                                                                        value
                                                                );
                                                            }}
                                                            value={
                                                                values.intAdult
                                                            }
                                                        />
                                                        <Counter
                                                            id="intChild"
                                                            type="number"
                                                            className="m-1"
                                                            onBlur={handleBlur}
                                                            title={"Child".pluralize(
                                                                values.intChild,
                                                                "ren"
                                                            )}
                                                            onChange={(
                                                                value
                                                            ) => {
                                                                setFieldValue(
                                                                    "intChild",
                                                                    value
                                                                );
                                                                setFieldValue(
                                                                    "totalPax",
                                                                    values.intAdult +
                                                                        value
                                                                );
                                                            }}
                                                            value={
                                                                values.intChild
                                                            }
                                                        />
                                                    </div>
                                                }
                                            />
                                        </Dropdown>
                                        <ErrorMessage name="totalPax" />
                                    </div>

                                    <div className="field-box flights-search-grid__nationality">
                                        <label htmlFor="strNationality">
                                            {t("Nationality")}
                                        </label>
                                        <Dropdown
                                            name="strNationality"
                                            placeholder="Select Country"
                                            className="icon btn-dropdown nationality"
                                            iconPosition="left"
                                            icon="globe"
                                            onBlur={handleBlur}
                                            onChange={(e, data) => {
                                                setFieldValue(
                                                    `strNationality`,
                                                    data.value
                                                );
                                            }}
                                            value={values.strNationality}
                                            fluid
                                            search
                                            selection
                                            selectOnBlur={false}
                                            options={countries || []}
                                        />
                                        <ErrorMessage name="strNationality" />
                                    </div>
                                    <div className="field-box flights-search-grid__submit">
                                        <button
                                            className="search-btn btn btn-primary btn-lg btn-block-md"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            {t("Search")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        );
    }
}

const mapStateToProps = ({ flightStore, extras }) => ({
    flights: flightStore.flights,
    searchDetails: flightStore.searchDetails,
    ttlTime: flightStore.ttlTime,
    countries: extras.countries,
});

const mapDispatchToProps = {
    setFlights,
    clearFlights,
    setSearchDetails,
    setTTLtime,
    setError,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SearchBar));
